import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
        };
    }
    componentDidCatch(error, errorInfo) {
        // Catch errors in any components below and re-render with error message
        this.setState({
            error: error,
        });
    }
    render() {
        const { error } = this.state;
        if (error) {
            // Error path
            return (_jsxs("div", { children: [_jsx("div", { children: "Something went wrong." }, void 0), _jsx("details", Object.assign({ style: { whiteSpace: 'pre-wrap' } }, { children: error && error.toString() }), void 0)] }, void 0));
        }
        // Normally, just render children
        return this.props.children;
    }
}
export default ErrorBoundary;
